// Detect Safari browser
const isSafari = function () {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
}

// Get optimal GPS settings based on browser
const getGPSOptions = function (attempt) {
    const safari = isSafari()

    if (attempt === 1) {
        return {
            enableHighAccuracy: !safari,
            timeout: safari ? 45000 : 15000,
            maximumAge: safari ? 600000 : 0,
        }
    } else {
        return {
            enableHighAccuracy: false,
            timeout: safari ? 90000 : 60000,
            maximumAge: 900000,
        }
    }
}

// Safari-specific error messages
const getSafariErrorMessage = function (error) {
    switch (error.code) {
        case error.PERMISSION_DENIED:
            return "Location access denied. On Safari:\n1. Safari > Settings for This Website > Location > Allow\n2. System Settings > Privacy & Security > Location Services > Safari > Allow"

        case error.POSITION_UNAVAILABLE:
            return "Location unavailable on Safari. Check:\n1. Location Services enabled\n2. Safari has permission\n3. Network connection available"

        case error.TIMEOUT:
            return "Safari location request timed out.\nTry again and ensure WiFi is connected."

        default:
            return "Unable to get location on Safari. Enable location services."
    }
}

// Standard browser error messages
const getStandardErrorMessage = function (error) {
    switch (error.code) {
        case error.PERMISSION_DENIED:
            return "Location permission denied. Please enable location access in your browser settings."
        case error.POSITION_UNAVAILABLE:
            return "Location unavailable. Please check: 1) Location services are enabled on your device, 2) You're using HTTPS, 3) Your network allows location access."
        case error.TIMEOUT:
            return "Location request timed out. Please try again."
        default:
            return "Unable to get location. Please ensure location services are enabled."
    }
}

// Attempt to get location
const attemptGetLocation = function (options) {
    return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                resolve({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                    accuracy: position.coords.accuracy,
                    timestamp: position.timestamp,
                })
            },
            (error) => {
                const errorMessage = isSafari()
                    ? getSafariErrorMessage(error)
                    : getStandardErrorMessage(error)

                reject(new Error(errorMessage))
            },
            options,
        )
    })
}

// Main function to export
export const getCurrentLocation = async function () {
    if (!navigator.geolocation) {
        throw new Error("Geolocation is not supported by your browser")
    }

    try {
        const coords = await attemptGetLocation(getGPSOptions(1))
        console.log("GPS acquired successfully (attempt 1)")
        return coords
    } catch (firstError) {
        console.warn("First GPS attempt failed:", firstError)

        try {
            console.log("Retrying with fallback settings...")
            const coords = await attemptGetLocation(getGPSOptions(2))
            console.log("GPS acquired successfully (attempt 2)")
            return coords
        } catch (secondError) {
            console.error("All GPS attempts failed:", secondError)
            throw secondError
        }
    }
}
